export default {"src":"/_next/static/media/no-job-matches.71dd7b22.svg","height":233,"width":232,"blurWidth":0,"blurHeight":0};